var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArtboard32(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        clip-path: url(#clip-Artboard_32);\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #656fb2;\r\n      }\r\n\r\n      .cls-4 {\r\n        filter: url(#Ellipse_304);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_304",
    x: -0.921,
    y: 2.579,
    width: 46.842,
    height: 46.842,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#8082d0",
    floodOpacity: 0.157
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_32"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 46
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_32",
    "data-name": "Artboard \\u2013 32",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2483",
    "data-name": "Group 2483",
    transform: "translate(-10534.449 -6753.921)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4",
    transform: "matrix(1, 0, 0, 1, 10534.45, 6753.92)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_304-2",
    "data-name": "Ellipse 304",
    className: "cls-2",
    cx: 14.421,
    cy: 14.421,
    r: 14.421,
    transform: "translate(8.08 8.58)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_964",
    "data-name": "Path 964",
    className: "cls-3",
    d: "M1233.182-30.941a.446.446,0,0,1,.057-.517c.189-.179.494-.1.737,0l1.521.585a1.091,1.091,0,0,1,.762.745c.33,1.011.7,2.008,1.057,3.011l.023.111.031.052a.19.19,0,0,0,.057.159.632.632,0,0,0,.091.273l.027.1.567,1.607a4.746,4.746,0,0,0,.279.8c.056.186.115.37.166.557a.244.244,0,0,0,.281.2q2.834-.011,5.667,0c.147,0,.225-.03.263-.185a5.077,5.077,0,0,1,.2-.63c.076-.2-.032-.179-.159-.155h-4.6l-.639-.012a.516.516,0,0,1-.4-.422.057.057,0,0,0,0-.049l.014-.109c.1-.3.345-.341.622-.341,1.747,0,3.495,0,5.242.007.242,0,.339-.091.356-.311.023-.291.3-.583.265-.884-1.033-.105-2.13-.006-3.17-.006h-3.237a.886.886,0,0,1-.353-.048.463.463,0,0,1-.136-.717.9.9,0,0,1,.649-.172l6.308.005a.326.326,0,0,0,.226-.057.324.324,0,0,0,.075-.14c.021-.063.272-.816.289-.816H1238.3a1.166,1.166,0,0,1-.446-.054.531.531,0,0,1-.223-.484.487.487,0,0,1,.534-.381q4.363,0,8.727,0c.348,0,.471.124.538.522.028.168-.193.553-.248.72-.32.967-.6,1.947-.9,2.919-.155.493-.316.985-.493,1.471a3.677,3.677,0,0,1-.458,1.159.909.909,0,0,1-.413.078c-.383,0-.766,0-1.149,0l-5.478.009c-.077-.029-.146-.057-.183.061-.076.24-.163.477-.246.715-.18.37-.18.371.216.369q1.6-.009,3.2-.009c.769,0,1.568,0,2.349-.006.4,0,.82-.044,1.221-.019.261.016.545.116.582.413-.068.5-.48.34-.815.39a1.463,1.463,0,0,1,.354,1.106,1.416,1.416,0,0,1-1.8,1.116,1.433,1.433,0,0,1-.64-2.216h-2.962a1.462,1.462,0,0,1,.334,1.211,1.376,1.376,0,0,1-1.714,1.015,1.467,1.467,0,0,1-.967-.91,1.542,1.542,0,0,1,.264-1.327,1.128,1.128,0,0,1-.43-.04c-.308-.113-.288-.385-.193-.645.131-.356.262-.712.392-1.069.106-.292.171-.716.443-.905a6.9,6.9,0,0,0-.463-1.409l-.553-1.6-1.121-3.243a1.608,1.608,0,0,0-.244-.5c-.336-.412-1.082-.527-1.563-.7a1.037,1.037,0,0,1-.525-.342A.5.5,0,0,1,1233.182-30.941Zm10.774,11.9h0a.587.587,0,0,0,.1-.855.583.583,0,0,0-.859-.054.145.145,0,0,0-.1.113.1.1,0,0,0-.054.1.146.146,0,0,0-.046.161l0,.159a.261.261,0,0,0,.079.221.434.434,0,0,0,.343.26.486.486,0,0,0,.481-.064C1243.939-18.991,1243.949-19.014,1243.957-19.04Zm-4.811-.454a.6.6,0,0,0-.59-.617.647.647,0,0,0-.645.611.674.674,0,0,0,.62.611A.614.614,0,0,0,1239.146-19.494Z",
    transform: "translate(9315.604 6801.765)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtboard32);
export default __webpack_public_path__ + "static/media/Artboard – 32.8894ac4b374110df77100b53ba022e89.svg";
export { ForwardRef as ReactComponent };